import { WorkflowsRoutes } from './type'

const workflows = `${WorkflowsRoutes.root}`

export const WorkflowsPath = {
  root: workflows,
}
